import { Chip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { ContactRole } from '../../../interfaces/IEvent'
import type { MouseEvent } from 'react'
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined'
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined'

interface ContactChipProps {
  label: string
  role: ContactRole
  onClick: (e: MouseEvent<HTMLDivElement, MouseEvent>) => void
}

export default function ContactChip({ label, role, onClick }: ContactChipProps) {
  const chipColor = () => {
    switch (role) {
      case ContactRole.Kontaktperson:
        return 'primary'
      case ContactRole.Bestiller:
        return 'success'
      default:
        return 'primary'
    }
  }

  const chipIcon = () => {
    switch (role) {
      case ContactRole.Kontaktperson:
        return <PermContactCalendarOutlinedIcon color={chipColor()} fontSize="small" />
      case ContactRole.Bestiller:
        return <SupervisedUserCircleOutlinedIcon color={chipColor()} fontSize="small" />
      default:
        return <InfoOutlinedIcon color={chipColor()} fontSize="small" />
    }
  }

  // @ts-ignore
  return <Chip icon={chipIcon()} label={label} color={'info'} variant="outlined" onClick={onClick} />
}
